import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-circular-progressbar/dist/styles.css'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import 'swiper/css/navigation'

import React, { Suspense, lazy } from 'react'
import {  Routes, Route} from 'react-router-dom'
import Layout from './pages/Layout'
import Loader from './components/Loader'
import ThankYou from './pages/AnalysisPage/ThankYou'
import LandingPage from './pages/LandingPage'
import PageNotFound from './components/PageNotFound'
import * as Sentry from "@sentry/react"
import FallbackUI from './components/FallbackUI'
import NewLoader from './components/NewLoader'
import CheckoutPage from './pages/CheckoutPage'
import NewSuspenseLoader from './components/NewSuspenseLoader'

const CourseAndSkillSelectionPage = lazy(()=> import('./pages/SkillSelectionPage'))
const OnboardingPage = lazy(() => import(/* webpackPrefetch: true */ './pages/OnboardingPage'))
const Register = lazy(() => import(/* webpackPrefetch: true */ './pages/Register'))
const BundlePage = lazy(() => import(/* webpackPrefetch: true */ './pages/BundlePage'))
const NewAnalysisPage = lazy(() => import(/* webpackPreload: true */'./pages/NewAnalysisPage'))
const AddOnPage = lazy(() => import(/* webpackPrefetch: true */ './pages/AddOnPage'))
const PostCertifcatePurchase = lazy(() => import('./pages/PostCertifcatePurchase'))
const SkillPage = lazy(() => import('./pages/SkillPage'))
const MCQPage = lazy(() => import('./pages/MCQPage'))
const CertifiedPricing = lazy(() => import('./pages/CertifiedPricingPage'))
const MultiskillSelection2 = lazy(() => import('./pages/MultiskillSelectionVersion2'))
const PricingPageVersion2 = lazy(() => import('./pages/PricingPage/PricingPageVersion2'))
const SkillLevelPage = lazy(() => import('./pages/PersonaliseSkillPage'))
const PersonaliseAnalysis = lazy(() => import('./pages/PersonaliseAnalysisPage'))
const PersonaliseQuestionarySection = lazy(() => import('./pages/PersonaliseQuestionsPage'))
const PersonalisedCourse = lazy(() => import('./pages/PersonaliseCoursePage'))
const CertificateCourse = lazy(() => import('./pages/CertifiedCoursePage'))
const CourseLoader = lazy(() => import('./components/CourseLoader'))
const PersonalisedPricing = lazy(() => import('./pages/PersonalisedPricingPage'))
const NewPaidPostPaymentThankYou = lazy(() => import('./pages/PostCertifcatePurchase/NewPaidPostPaymentThankYou'))
const NewRedeemPage = lazy(() => import('./pages/NewRedeemPage'))
const UnPaidUsers = lazy(() => import('./pages/UnPaidUsers'))
const SuggestedBundle = lazy(() => import('./pages/SuggestedBundle'))


function App() {

    return (
        <Sentry.ErrorBoundary fallback={({ resetError }) => <FallbackUI resetError={resetError}/>}>
            <Routes>
                <Route path='/' element={<Layout/>}>
                    <Route path=':skill_name?/:utm_source?' element={<Suspense fallback={<Loader/>}><LandingPage/></Suspense>}/>
                    <Route path='1/course-page' element={<Suspense fallback={<Loader/>}><CourseAndSkillSelectionPage/></Suspense>}/>
                    <Route path='2/skill-page' element={<Suspense fallback={<Loader/>}><SkillPage/></Suspense>}/>
                    <Route path='mcq/:id' element={<Suspense fallback={<Loader/>}><MCQPage/></Suspense>}/>
                    <Route path='checkout' element={<CheckoutPage/>}/>
                    <Route path='analysis'>
                        <Route path='certificate-bundle' element={<Suspense fallback={<Loader />}><BundlePage /></Suspense>} />
                        <Route path='course-bundle' element={<Suspense fallback={<Loader />}><AddOnPage /></Suspense>}/>
                        <Route path='leaderboard'>
                            <Route path='v2' element={<Suspense fallback={<Loader/>}><PostCertifcatePurchase/></Suspense>}/>
                            <Route path='un-paid' element={<Suspense fallback={<Loader/>}><PostCertifcatePurchase/></Suspense>}/>
                            <Route path='bundle-page' element={<Suspense fallback={<Loader/>}><SuggestedBundle /></Suspense>}/>
                        </Route>
                        <Route path='skillcertificates/v2' element={<Suspense fallback={<Loader/>}><MultiskillSelection2/></Suspense>}/>
                        <Route path='thank-you' element={<Suspense fallback={<Loader/>}><NewPaidPostPaymentThankYou /></Suspense>}/>
                    </Route>
                    <Route path='personalised-course'>
                        <Route index element={<Suspense fallback={<Loader/>}><SkillLevelPage/></Suspense>} />
                        <Route path='questions/:id' element={<Suspense fallback={<Loader/>}><PersonaliseQuestionarySection/></Suspense>} />
                        <Route path='loader' element={<Suspense fallback={<Loader/>}><CourseLoader/></Suspense>} />
                        <Route path='certificate-course' element={<Suspense fallback={<Loader/>}><CertificateCourse/></Suspense>} />
                        <Route path='analysis' element={<Suspense fallback={<Loader/>}><PersonaliseAnalysis/></Suspense>} />
                        <Route path='pricing' element={<Suspense fallback={<Loader/>}><CertifiedPricing/></Suspense>} />
                        <Route path='personalised-pricing' element={<Suspense fallback={<Loader/>}><PersonalisedPricing/></Suspense>} />
                        <Route path='course' element={<Suspense fallback={<Loader/>}><PersonalisedCourse/></Suspense>} />
                    </Route>
                    <Route path='pricing'>
                        <Route index element={<Suspense fallback={<Loader/>}><PricingPageVersion2/></Suspense>}/>
                        <Route path='thank-you' element={<Suspense fallback={<Loader/>}><ThankYou/></Suspense>}/>
                    </Route>
                    <Route path='/error' element={<PageNotFound/>}/>
                    <Route path='*' element={<PageNotFound/>}/>
                </Route>
                <Route path='/onboarding' element={<Suspense fallback={<NewLoader />}><OnboardingPage/></Suspense>}/>
                <Route path='register' element={<Suspense fallback={<NewSuspenseLoader trackEvent={false}/>}><Register /></Suspense>}/>
                <Route path='/analysis'>
                    <Route path=':token?' element={<Suspense fallback={<NewLoader />}><NewAnalysisPage /></Suspense>} />
                    <Route path='leaderboard/paid' element={<Suspense fallback={<NewLoader />}><NewRedeemPage /></Suspense>} />
                    <Route path='un-paid' element={<Suspense fallback={<NewLoader />}><UnPaidUsers /></Suspense>} />
                </Route>
            </Routes>
        </Sentry.ErrorBoundary>
    )
}

export default App;
